<template>
  <div class="help">
    <div class="max-width">
      <div class="subs">
        <router-link to="/" class="subs__links">Home</router-link>
        <span>Help Center</span>
      </div>

      <div class="help__head">
        <div class="section__head">
          <h1 class="section__title">Help Center</h1>
          <div class="section__text">Explore our detailed documentation and benefit from support. </div>
        </div>
      </div>

      <div class="help__container">
        <div class="help__grid">
          <router-link
              v-for="doc in docs"
              :key="doc.link"
              :to="doc.link"
              class="help__item fadeIn"
          >
            <span class="help__icon" v-html="doc.icon"></span>
            <h3 class="help__title">{{ doc.title }}</h3>
            <span class="help__link">
              View Documentation
              <IconArrow/>
            </span>
          </router-link>
        </div>

        <div class="help__support" id="support">
          <div class="section__head">
            <h2 class="section__title">Support Request</h2>
          </div>

          <div class="help__form fadeIn">
            <h3 class="help__form-title">Submit Ticket</h3>
            <div class="help__form-text">Estimated wait time 2+ business days.</div>
            <form class="sh-form sh-form_help form-support">
              <input type="hidden" name="TYPE_FORM" value="ticket">
              <input type="hidden" name="PORTFOLIO" value="Creative Commerce">

              <div class="sh-form__grid">
                <div class="sh-form__inner">
                  <div class="sh-form__field">
                    <label>Name<span>*</span></label>
                    <input
                        class="input-text input-name"
                        type="text"
                        name="Name"
                        placeholder="Your Name"
                        required
                    />
                  </div>
                  <div class="sh-form__field">
                    <label>E-mail<span>*</span></label>
                    <input
                        class="input-text input-email"
                        type="email"
                        name="Email"
                        placeholder="Your e-mail"
                        required
                    />
                  </div>
                </div>
                <div class="sh-form__field sh-form__field_w3">
                  <label>Subject <span>*</span></label>
                  <input
                      class="input-text input-subject"
                      type="text"
                      name="Subject"
                      placeholder="Subject"
                      required
                  />
                </div>
                <div class="sh-form__field sh-form__field_w3">
                  <label>Theme<span>*</span></label>
                  <select class="input-text input-text_white input-theme" name="Theme" required>
                    <option value="" disabled selected>Select Theme</option>
                    <option value="Megastore">Megastore</option>
                    <option value="Mix">Mix</option>
                    <option value="Force">Force</option>
                  </select>
                </div>
                <div class="sh-form__field sh-form__field_w3">
                  <label>Site URL</label>
                  <input
                      class="input-text input-url"
                      type="url"
                      name="SiteURL"
                      placeholder="URL"
                  />
                </div>
                <div class="sh-form__field sh-form__field_full">
                  <label>Request<span>*</span></label>
                  <textarea
                      class="input-text input-message"
                      name="Message"
                      placeholder="Your Request"
                      required
                  ></textarea>
                </div>
              </div>

              <div class="sh-form__note">
                Please, read this before attaching a file: If you want to add more than one file, please, create a ZIP archive containing these files. Please, do not attach a ZIP archive of the theme, as email client may block messages with such attachments.
              </div>

              <div class="sh-form__file">
                <input
                    class="input-file"
                    type="file"
                    accept=".png,.jpg,.jpeg,.zip,.pdf"
                    id="input-file"
                    name="file[]"
                    multiple
                    placeholder="File"
                    hidden
                />
                <label class="sh-form__file-label" for="input-file">
                  <span class="input-file-text">Add File</span>
                  <span class="input-file-accept">
									Allowed file formats: jpeg, png, jpg, pdf and zip. <br />
									Maximum upload file size: 20MB
								</span>
                </label>
              </div>

              <div class="sh-form__checkboxes">
                <div class="sh-form-checkbox">
                  <input type="checkbox" name="AGREEMENT" class="checkbox-terms" id="checkbox-terms">
                  <label for="checkbox-terms">I agree to the <router-link to="/terms" target="_blank">Terms</router-link> & <router-link to="/privacy" target="_blank">Privacy Policy</router-link></label>
                </div>
                <div class="sh-form-checkbox">
                  <input type="checkbox" name="SUBSCRIBE" id="checkbox-newsletter">
                  <label for="checkbox-newsletter">Keep me updated with theme news and tips</label>
                </div>
                <div class="sh-form-checkbox">
                  <input type="checkbox" name="QUESTION_PRE_PURCHASE" id="checkbox-question">
                  <label for="checkbox-question">I have a pre-purchase question</label>
                </div>
              </div>

              <button class="sh-form__submit" type="submit">
                <span class="button button_dark">
                  Send Request
                  <IconArrow/>
                <div class="sh-form-loader"></div>
                </span>
              </button>

              <p class="sh-from-message"></p>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>

  <SubscribeNewsletterView/>
</template>

<script setup>
import IconArrow from '@/components/icons/IconArrow.vue'
import {ref, onMounted} from 'vue'
import JustValidate from 'just-validate'

import { useHead } from '@vueuse/head'
import SubscribeNewsletterView from "@/components/SubscribeNewsletterView.vue";

useHead({
  title: 'Help Center – Creative Commerce',
  meta: [
    { name: 'description', content: 'Explore Creative Commerce Labs Help Center for guides, tutorials, and expert tips to fix bugs, customize, and optimize your Shopify themes.' }
  ]
})

const docs = ref([])
const listId = 'help'

onMounted(async () => {
  const res = await fetch('/assets/json/docs.json')
  const data = await res.json()
  docs.value = data.filter(d => !d.hiddenIn?.includes(listId))

  const urlParams = new URLSearchParams(window.location.search)
  const theme = urlParams.get('theme')
  const source = urlParams.get('source')

  if (theme) {
    const themeSelect = document.querySelector('.form-support select[name="Theme"]')
    if (themeSelect) themeSelect.value = theme
  }

  if (source) {
    const sourceInput = document.querySelector('.form-support input[name="source_form"]')
    if (sourceInput) sourceInput.value = source
  }

  const form = document.querySelector('.form-support')

  if (form) {
    const validation = new JustValidate(form)

    validation
        .addField('.checkbox-terms', [
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please select agrees'
          }
        ])
        .addField('.input-name', [
          {
            rule: 'minLength',
            value: 3
          },
          {
            rule: 'maxLength',
            value: 30
          },
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please enter your first name'
          }
        ])
        .addField('.input-email', [
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please enter your email'
          },
          {
            rule: 'email',
            value: true
          }
        ])
        .addField('.input-subject', [
          {
            rule: 'minLength',
            value: 5
          },
          {
            rule: 'maxLength',
            value: 300
          },
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please enter your subject'
          }
        ])
        .addField('.input-theme', [
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please select your theme'
          }
        ])
        .addField('.input-url', [
          {
            rule: 'minLength',
            value: 3
          },
          {
            rule: 'maxLength',
            value: 200
          }
        ])
        .addField('.input-message', [
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please enter your message'
          }
        ])
        .addField('.input-file', [
          {
            rule: 'files',
            value: {
              files: {
                extensions: ['jpeg', 'png', 'jpg', 'pdf', 'zip'],
                maxSize: 20000000,
                minSize: 1000
              }
            },
            errorMessage: 'Uploaded files have invalid format or size'
          }
        ])
        .onSuccess((event) => {
          const formData = new FormData(event.target)
          const xhr = new XMLHttpRequest()

          form.classList.add('loading')

          const messageEl = document.querySelector('.sh-from-message')
          messageEl.classList.remove('sh-from-message_success', 'sh-from-message_error')
          messageEl.textContent = ''

          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                messageEl.textContent = 'Thank you for your submission! We will contact you shortly.'
                messageEl.classList.add('sh-from-message_success')
                event.target.reset()
              } else {
                messageEl.textContent = 'Something went wrong.'
                messageEl.classList.add('sh-from-message_error')
              }
              form.classList.remove('loading')
            }
          }

          xhr.open('POST', 'https://creativecommercelabs.com/contact.php', true)
          xhr.send(formData)
        })

    let inputs = document.querySelectorAll('.input-file')
    Array.prototype.forEach.call(inputs, function (input) {
      let label = input.nextElementSibling
      let labelVal = label.querySelector('.input-file-text').innerText

      input.addEventListener('change', function () {
        let countFiles = this.files?.length || 0
        label.querySelector('.input-file-text').innerText = countFiles ? 'Selected files: ' + countFiles : labelVal
      })
    })
  }
})
</script>

<style lang="scss">
.help {
  &__head {
    margin: 0 0 2.5rem;

    .section__head {
      max-width: 540px;
      margin: 0;
    }

    .section__title {
      font-size: 4rem;

      @include xs {
        font-size: 2.5rem;
      }
    }

    .section__text {
      max-width: 100%;
    }
  }

  &__container {
    display: flex;
    gap: 7.5rem;
    flex-direction: column;

    @include xs {
      gap: 4rem;
    }

    .section__head {
      margin: 0 0 2.5rem;
      max-width: 430px;
    }

    .section__title {
      font-size: 2.5rem;

      @include xs {
        font-size: 2rem;
      }
    }

    .section__text {
      max-width: 100%;
    }
  }

  &__grid {
    display: grid;
    grid-template-columns:repeat(2, 1fr);
    gap: 2rem;

    @include xs {
      grid-template-columns:repeat(1, 1fr);
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    border: 1px solid transparent;
    padding: 2rem;
    background: #fff;
    border-radius: 12px;

    &:hover {
      border-color: var(--color-border);
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: linear-gradient(110deg, #bbff4c 0%, #378cff 75%, #cffff2 87.98%);
    width: 66px;
    height: 66px;
    margin: 0 0 2.5rem;

    @include xs {
      width: 50px;
      height: 50px;

      svg {
        width: 32px;
        height: 32px;
      }
    }
  }

  &__title {
    margin: 0 0 .5rem;
    font-size: 1.5rem;
    font-weight: 600;
  }

  &__link {
    display: flex;
    align-items: center;
    transition: var(--transition);
    color: var(--color-main);
    gap: 6px;

    svg {
      transition: var(--transition);
    }
  }

  &__item:hover &__link {
    color: var(--color-accent);

    svg {
      transform: translateX(3px);
    }
  }

  &__support {
    .sh-form .sh-from-message {
      text-align: left;
    }

    &-grid {
      display: grid;
      grid-template-columns:repeat(3, 1fr);
      gap: 2rem;

      @include md {
        grid-template-columns:repeat(2, 1fr);
      }

      @include xs {
        grid-template-columns:repeat(1, 1fr);
      }
    }

    &-item {
      padding: 32px;
      background: #fff;
      border-radius: 12px;
      min-height: 190px;
      gap: 1rem;
      display: flex;
      flex-direction: column;
      font-weight: 600;
      font-size: 1.125rem;

      @include xs {
        font-size: 1rem;
        min-height: initial;
        padding: 1.5rem;
      }
    }
  }

  &__form {
    border-radius: 12px;
    padding: 1.75rem;
    background: #fff;

    &-title {
      font-size: 1.5rem;
      font-weight: 600;
      margin: 0 0 4px;
    }

    &-text {
      color: var(--color-gray);
      margin: 0 0 1.5rem;
    }


  }
}
</style>
